import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeviceHealthService {
  deviceHealthUrl: string = environment.deviceHealth;

  constructor(private httpClient: HttpClient) {}

  getDeviceHealthResponse(
    query: DeviceHealthQuery,
  ): Promise<DeviceHealthResponse> {
    if (query.selectedQuery === 'Device') {
      return this.httpClient
        .post<DeviceHealthResponse>(
          `${this.deviceHealthUrl}/devicehealth`,
          query,
        )
        .toPromise();
    }

    return this.httpClient
      .post<DeviceHealthResponse>(
        `${this.deviceHealthUrl}/installhealth`,
        query,
      )
      .toPromise();
  }

  getDeviceHealthResponseCsv(query: DeviceHealthQuery): Promise<string> {
    const queryWithNoScroll = query;
    queryWithNoScroll.scrollId = null;
    if (query.selectedQuery === 'Device') {
      return this.httpClient
        .post<string>(
          `${this.deviceHealthUrl}/devicehealth/csv`,
          queryWithNoScroll,
          { responseType: 'text' as 'json' },
        )
        .toPromise();
    }

    return this.httpClient
      .post<string>(
        `${this.deviceHealthUrl}/installhealth/csv`,
        queryWithNoScroll,
        { responseType: 'text' as 'json' },
      )
      .toPromise();
  }

  deleteScrollId(query: DeviceHealthQuery): Promise<void> {
    return this.httpClient
      .delete<void>(`${this.deviceHealthUrl}/scroll?scrollId=${query.scrollId}`)
      .toPromise();
  }
}

export interface DeviceHealthQuery {
  selectedQuery: string;
  serialNumbers: string[];
  healthParams: string[];
  companyId: number;
  sortOrder: string;
  startDate: string;
  endDate: string;
  scrollId?: string;
  size?: number;
}

export interface DeviceHealthResponse {
  devices: DeviceHealth[];
  total: number;
  totalHealthy: number;
  totalUnhealthy: number;
  scrollId: string;
  unhealthyCount: {
    [key: string]: number;
  };
}

export interface TotalResponse {
  total: number;
  totalHealthy: number;
}

export interface DeviceHealth {
  companyId: number;
  companyName: string;
  groupName: string;
  timestamp: string;
  serialNumber: string;
  totalGrade: string;
  calibrationGrade: string;
  checkInGrade: string;
  presenceGrade: string;
  inServiceGrade: string;
  ignitionGrade: string;
  gpsGrade: string;
  can1Type: string;
  ecmDataGrade: string;
  sdCardHealthGrade: string;
  hubAssociationGrade: string;
  vehicleAssociationGrade: string;
  vehicleMeasurementGrade: string;
  accelerometerGrade: string;
  installEcmIgnitionGrade: string;
  installEcmEngineSpeedGrade: string;
  installDate: string;
  installerType: string;
}
